<template>
    <div
        class="view-settings"
    >
        <div
                v-if="isPreloader"
                class="preloader-content fa fa-circle-o-notch fa-spin">
        </div>
        <div v-if="isEmpty">
            Логи не найдены
        </div>
        <div
                v-for="(logItem, logIndex) in linkList"
                :key="logIndex"
        >
            <a :href="logItem.url" target="_blank">{{logItem.name}}</a>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import schemeApi from '../../schemes/schemeApi';
let {
    routeLogLinks
} = schemeApi;
export default {
    name: 'ViewSettingsLogs',
    components: {

    },
    /**
     * Данные компонента
     * @property {array} linkList - список ссылок
     * @property {boolean} isSettingsPermission - право на показ настроек редактирования
     * @property {boolean} isPreloader
     * @property {boolean} проверка ответа на пустоту
     */
    data: () => ({
        linkList: [],
        isSettingsPermission: false,
        isPreloader: false,
        isEmpty: false
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        })
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Логи");
        this.getLinks();
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на получение ссылок на логи
         * @async
         */
        async getLinks() {
            this.isPreloader = true;
            try {
                let {data = []} = await serviceApi.post(routeLogLinks);
                if(!data.length){
                    this.isEmpty = true;
                }
                this.linkList = data;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isPreloader = false;
        },
    }
}
</script>

<style lang="scss" scoped>
    .view-settings {
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .preloader-content {
        margin-left: 50%;
        font-size: 24px;
    }
</style>